export enum InventoryTypeRef {
  AuxiliaryRawMaterials = '6866c33a245e3504d98d3a44',
}
